import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ReverseChargeAvailableOnlyForVatPayerWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.sale.validation.client.reverse-charge-available-only-for-vat-payer');
    }
}
